module.exports = __webpack_public_path__ + "static/media/Rossmann_Light.839437c5.woff2";